import { getEntries } from '@gov-nx/core/types';
import {
	useRezaLocale,
	useRezaTemplateDetailContext,
} from '@gov-nx/module/page';
import {
	ContentLayout,
	CopyButton,
	DataTable,
	ErrorStatusBanner,
	LayoutGap,
} from '@gov-nx/ui/web';
import { CmsPageRender } from '../../../../Cms/CmsPageRender';
import { PortalInfo } from '../../PortalInfo';
import { RezaTemplateDetailSkeleton } from './RezaTemplateDetailSkeleton';

export const RezaTemplateDetail = () => {
	const { code, isLoading, isError, template, keyValues, portalInfo } =
		useRezaTemplateDetailContext();
	const { t } = useRezaLocale();

	if (isLoading) {
		return <RezaTemplateDetailSkeleton />;
	}

	if (isError) {
		return <ErrorStatusBanner code={code} />;
	}

	return (
		<CmsPageRender
			code={code}
			override={{ name: template?.nazev }}>
			<ContentLayout>
				<LayoutGap>
					<DataTable responsive={true}>
						<tbody>
							{getEntries(keyValues).map(([key, { value, isCopyable }]) => (
								<tr key={key}>
									<td className="sm:w-1/2">{key}</td>
									<td className="sm:w-1/2">
										<strong>{value}</strong>
										{isCopyable ? (
											<CopyButton
												value={value}
												label={t('detail.buttons.zkopirovat-do-schranky')}
											/>
										) : null}
									</td>
								</tr>
							))}
						</tbody>
					</DataTable>

					{portalInfo?.portalURL && portalInfo?.portalName ? (
						<PortalInfo portalInfo={portalInfo} />
					) : null}
				</LayoutGap>
			</ContentLayout>
		</CmsPageRender>
	);
};
